import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { StudyItem } from '../StudyItem';
import { StudyBrowserSort } from '../StudyBrowserSort';
import { StudyBrowserViewOptions } from '../StudyBrowserViewOptions';
import DeleteSeries from './DeleteSeries';
import { deleteData, fetchData } from '../../../../../extensions/cornerstone/src/utils/APIService';
import WarningDeleteImg from './WarningDeleteImg';
import { DicomMetadataStore, utils } from '@ohif/core';
import { getEnabledElementByViewportId } from '@cornerstonejs/core';

const getTrackedSeries = displaySets => {
  let trackedSeries = 0;
  displaySets.forEach(displaySet => {
    if (displaySet.isTracked) {
      trackedSeries++;
    }
  });

  return trackedSeries;
};

const noop = () => {};

const StudyBrowser = ({
  tabs,
  activeTabName,
  expandedStudyInstanceUIDs,
  onClickTab = noop,
  onClickStudy = noop,
  onClickThumbnail = noop,
  onDoubleClickThumbnail = noop,
  onClickUntrack = noop,
  activeDisplaySetInstanceUIDs,
  servicesManager,
  showSettings,
  viewPresets,
  onThumbnailContextMenu,
}: withAppTypes) => {
  const getTabContent = () => {
    const { uiDialogService, viewportGridService, uiModalService, hangingProtocolService } =
      servicesManager.services;

    const { protocol } = hangingProtocolService.getActiveProtocol();
    const isMpr = protocol?.id === 'mpr';
    const isMobile = /Android|iPod/.test(navigator.userAgent)
      ? true
      : navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        navigator.platform.includes('MacIntel');

    const idDialog = 'delete-series';
    const dismiss = () => uiDialogService.dismiss({ id: idDialog });
    const [isLoading, setIsLoading] = useState(false);
    const tabData = tabs.find(tab => tab.name === activeTabName);
    const viewPreset = viewPresets
      ? viewPresets.filter(preset => preset.selected)[0]?.id
      : 'thumbnails';
    // console.warn('tabData.studies ', tabData.studies);
    const accessToken = localStorage.getItem('access_token');
    const userString = localStorage.getItem('user');
    const user = userString ? JSON.parse(userString) : null;

    const [expiredDateLink, setExpiredDateLink] = useState<string>();

    DicomMetadataStore.subscribe(DicomMetadataStore.EVENTS.INSTANCES_ADDED, study => {
      setExpiredDateLink(study.UrlExpiryDateTime);
    });

    useEffect(() => {
      if (expiredDateLink) {
        const dicomDate = expiredDateLink.substring(0, 8);
        const dicomTime = expiredDateLink.substring(8, 14);
        const formattedDate = utils.formatDate(dicomDate);
        const formattedTime = utils.formatTime(dicomTime);
        // console.log('UrlExpiryDateTime', `${formattedDate} ${formattedTime}`);
        uiModalService.show({
          content: WarningDeleteImg,
          contentProps: {
            onClose: uiModalService.hide,
            message: (
              <>
                Viewer ini memiliki batas akses hingga <br />
                <b>
                  {formattedDate} {formattedTime}
                </b>
              </>
            ),
            isError: false,
            isInfo: true,
          },
          containerDimensions: 'w-[90%] max-w-lg',
          title: '',
          closeButton: false,
          shouldCloseOnOverlayClick: true,
        });
      }
    }, [expiredDateLink]);

    // const linkExpired = DicomMetadataStore.getStudy(tabData.studies[0].StudyInstanceUID)

    // if (!accessToken) {
    //   uiNotificationService.show({
    //     title: 'DICOM PRINT',
    //     message: 'Unauthorized, please log in as Admin from ONICS RIS-PACS',
    //     type: 'error',
    //   });
    //   return;
    // }
    const onConfirm = async (
      values: any,
      studyInstanceUID: string,
      seriesInstanceUID: string,
      SOPInstanceUID: string = null
    ) => {
      try {
        // Contoh pemanggilan API POST
        // console.warn(values);
        setIsLoading(true);
        if (!accessToken || !user || user.Role !== 'SUPERADMIN') {
          uiModalService.show({
            content: WarningDeleteImg,
            contentProps: {
              onClose: uiModalService.hide,
              message: 'Unauthorized, Mohon login sebagai SUPER ADMIN',
              isError: true,
            },
            containerDimensions: 'w-[90%] max-w-lg',
            title: 'HAPUS SERIES GAGAL',
            closeButton: false,
            shouldCloseOnOverlayClick: false,
          });
          return;
        }

        const endPoint = SOPInstanceUID
          ? `/studies/${studyInstanceUID}?series=${seriesInstanceUID}&instance=${SOPInstanceUID}`
          : `/studies/${studyInstanceUID}?series=${seriesInstanceUID}`;
        const response = await deleteData(endPoint, { reason: values }, accessToken);
        // console.warn('formData success', frmData);
        // console.warn(response);
        if (response.success) {
          // Tampilkan notifikasi sukses
          // uiNotificationService.show({
          //   title: 'DELETE SERIES SUCCESSFULLY',
          //   message: response.data.message,
          //   type: 'success',
          // });
          setTimeout(() => {
            setIsLoading(false);
            uiModalService.show({
              content: WarningDeleteImg,
              contentProps: {
                onClose: () => {
                  uiModalService.hide;
                  refreshViewer();
                },
                message: `Hapus berhasil, silahkan klik Close di bawah ini`,
                isError: false,
              },
              containerDimensions: 'w-[90%] max-w-lg',
              title: '',
              closeButton: false,
              shouldCloseOnOverlayClick: false,
            });
          }, 200);
        } else {
          uiModalService.show({
            content: WarningDeleteImg,
            contentProps: {
              onClose: uiModalService.hide,
              message: `ERROR : ${response.message}`,
              isError: true,
            },
            containerDimensions: 'w-[90%] max-w-lg',
            title: 'HAPUS SERIES ERROR',
            closeButton: false,
            shouldCloseOnOverlayClick: false,
          });
          setIsLoading(false);
        }
      } catch (err) {}
    };

    const refreshViewer = () => {
      dismiss();
      window.parent.postMessage({ status: 'reloadViewer' }, '*');
      setTimeout(() => {
        window.location.reload();
      }, 100);
    };

    const deleteSeriesConfirmation = (displaySetInstanceUID: string) => {
      // AMBIL Properti displaySets untuk mendapatkan study dan series instanceUID
      const { displaySetService, userAuthenticationService } = servicesManager.services;

      const displaySet = displaySetService.getDisplaySetByUID(displaySetInstanceUID);
      const listDisplaySets = displaySetService.getActiveDisplaySets();
      const studyInstanceUID = displaySet.StudyInstanceUID;
      const seriesInstanceUID = displaySet.SeriesInstanceUID;

      // cek apakah sudah ada duplikasi
      const count = listDisplaySets.filter(ds => ds.SeriesInstanceUID === seriesInstanceUID).length;

      const isDuplicate = count > 1;

      if (isDuplicate) {
        // uiNotificationService.show({
        //   title: 'PERINGATAN!',
        //   message: `Series UID duplikat, silahkan gunakan hapus Instance`,
        //   type: 'warning',
        // });
        uiModalService.show({
          content: WarningDeleteImg,
          contentProps: {
            onClose: uiModalService.hide,
            message: `Series UID duplikat, silahkan gunakan hapus Instance`,
            isError: true,
          },
          containerDimensions: 'w-[90%] max-w-lg',
          title: '',
          closeButton: false,
          shouldCloseOnOverlayClick: false,
        });
        return;
      }

      // console.warn(' userAuthenticationService', userAuthenticationService.getUser());

      // pastikan jumlah series lebih dari 1
      const listStudy = tabData.studies.find(item => item.studyInstanceUid === studyInstanceUID);

      if (listStudy.displaySets.length === 1) {
        // uiNotificationService.show({
        //   title: 'PERINGATAN!',
        //   message: `Study minimal memiliki 1 series, silahkan hapus melalui Hapus Study di RIS`,
        //   type: 'warning',
        // });
        uiModalService.show({
          content: WarningDeleteImg,
          contentProps: {
            onClose: uiModalService.hide,
            message: `Study minimal memiliki 1 series 1 instance, silahkan hapus melalui Hapus Study di RIS`,
            isError: true,
          },
          containerDimensions: 'w-[90%] max-w-lg',
          title: '',
          closeButton: false,
          shouldCloseOnOverlayClick: false,
        });
        return;
      }
      // console.warn('tabData.studies ', listStudy.displaySets.length);
      // console.warn('listStudy ', listStudy.displaySets);
      // console.warn('listDisplaySets ', listDisplaySets);
      // console.warn('displaySet ', displaySet);

      // tampil dialog konfirmasi hapus
      uiModalService.show({
        content: DeleteSeries,
        contentProps: {
          isLoading: isLoading,
          onClose: uiModalService.hide,
          onSubmit: val => onConfirm(val, studyInstanceUID, seriesInstanceUID),
        },
        containerDimensions: 'w-[90%] max-w-[900px]',
        title: 'Konfirmasi Hapus',
        // closeButton: false,
        shouldCloseOnOverlayClick: false,
      });
    };

    const deleteInstanceConfirmation = (displaySetInstanceUID: string) => {
      // AMBIL Properti displaySets untuk mendapatkan study dan series instanceUID
      const { displaySetService } = servicesManager.services;
      const displaySet = displaySetService.getDisplaySetByUID(displaySetInstanceUID);
      const studyInstanceUID = displaySet.StudyInstanceUID;
      const seriesInstanceUID = displaySet.SeriesInstanceUID;

      // ambil current image viewport
      const { activeViewportId } = viewportGridService.getState();
      const { viewport } = getEnabledElementByViewportId(activeViewportId);
      const instances = DicomMetadataStore.getInstanceByImageId(viewport.getCurrentImageId());
      const instanceUID = instances.SOPInstanceUID;

      // pastikan jumlah series lebih dari 1
      const listDisplaySets = displaySetService.getActiveDisplaySets();
      // cek apakah sudah ada duplikasi
      const count = listDisplaySets.filter(ds => ds.SeriesInstanceUID === seriesInstanceUID).length;

      const isDuplicate = count > 1;

      if (displaySet.instances.length === 1 && !isDuplicate) {
        // uiNotificationService.show({
        //   title: 'PERINGATAN!',
        //   message: `Study minimal memiliki 1 series, silahkan hapus melalui Hapus Study di RIS`,
        //   type: 'warning',
        // });
        uiModalService.show({
          content: WarningDeleteImg,
          contentProps: {
            onClose: uiModalService.hide,
            message: `Series minimal memiliki 1 instance, silahkan hapus melalui Hapus Series`,
            isError: true,
          },
          containerDimensions: 'w-[90%] max-w-lg',
          title: '',
          closeButton: false,
          shouldCloseOnOverlayClick: false,
        });
        return;
      }
      // console.warn('tabData.studies ', listStudy.displaySets.length);
      // console.warn('listStudy ', listStudy.displaySets);
      // console.warn('displaySet ', displaySet);
      // console.warn('instanceUID ', instanceUID);

      // tampil dialog konfirmasi hapus
      uiModalService.show({
        content: DeleteSeries,
        contentProps: {
          isLoading: isLoading,
          onClose: uiModalService.hide,
          type: 'instance',
          onSubmit: val => onConfirm(val, studyInstanceUID, seriesInstanceUID, instanceUID),
        },
        containerDimensions: 'w-[90%] max-w-[900px]',
        title: 'Konfirmasi Hapus',
        // closeButton: false,
        shouldCloseOnOverlayClick: false,
      });
      // uiDialogService.create({
      //   id: idDialog,
      //   centralize: true,
      //   isDraggable: false,
      //   showOverlay: true,
      //   content: DeleteSeries,
      //   contentProps: {
      //     isLoading: isLoading,
      //     onClose: () => dismiss(),
      //     onSubmit: val => onConfirm(val, studyInstanceUID, seriesInstanceUID),
      //   },
      // });
    };

    const notifExpiredLink = () => {
      return <></>;
    };

    return tabData.studies.map(
      ({ studyInstanceUid, date, description, numInstances, modalities, displaySets }) => {
        const isExpanded = expandedStudyInstanceUIDs.includes(studyInstanceUid);
        return (
          <React.Fragment key={studyInstanceUid}>
            <StudyItem
              date={date}
              description={description}
              numInstances={numInstances}
              isExpanded={isExpanded}
              displaySets={displaySets}
              modalities={modalities}
              trackedSeries={getTrackedSeries(displaySets)}
              isActive={isExpanded}
              onClick={() => {
                onClickStudy(studyInstanceUid);
              }}
              onClickThumbnail={isMobile && isMpr ? () => {} : onClickThumbnail}
              onDoubleClickThumbnail={isMobile && isMpr ? () => {} : onDoubleClickThumbnail}
              onClickUntrack={onClickUntrack}
              activeDisplaySetInstanceUIDs={activeDisplaySetInstanceUIDs}
              data-cy="thumbnail-list"
              viewPreset={viewPreset}
              onThumbnailContextMenu={onThumbnailContextMenu}
              studyInstanceUID={studyInstanceUid}
              onClickDeleteSeries={deleteSeriesConfirmation}
              onClickDeleteInstance={deleteInstanceConfirmation}
            />
          </React.Fragment>
        );
      }
    );
  };

  return (
    <div
      className="ohif-scrollbar invisible-scrollbar flex flex-1 flex-col gap-[4px] overflow-auto bg-[#363942]"
      data-cy={'studyBrowser-panel'}
    >
      <div>
        {showSettings && (
          <div className="w-100 flex h-[48px] items-center justify-center gap-[10px] bg-[#363942] px-[8px] py-[10px]">
            <>
              <StudyBrowserViewOptions
                tabs={tabs}
                onSelectTab={onClickTab}
                activeTabName={activeTabName}
              />
              <StudyBrowserSort servicesManager={servicesManager} />
            </>
          </div>
        )}
        {getTabContent()}
      </div>
    </div>
  );
};

StudyBrowser.propTypes = {
  onClickTab: PropTypes.func.isRequired,
  onClickStudy: PropTypes.func,
  onClickThumbnail: PropTypes.func,
  onDoubleClickThumbnail: PropTypes.func,
  onClickUntrack: PropTypes.func,
  activeTabName: PropTypes.string.isRequired,
  expandedStudyInstanceUIDs: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeDisplaySetInstanceUIDs: PropTypes.arrayOf(PropTypes.string),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      studies: PropTypes.arrayOf(
        PropTypes.shape({
          studyInstanceUid: PropTypes.string.isRequired,
          date: PropTypes.string,
          numInstances: PropTypes.number,
          modalities: PropTypes.string,
          description: PropTypes.string,
          displaySets: PropTypes.arrayOf(
            PropTypes.shape({
              displaySetInstanceUID: PropTypes.string.isRequired,
              imageSrc: PropTypes.string,
              imageAltText: PropTypes.string,
              seriesDate: PropTypes.string,
              seriesNumber: PropTypes.any,
              numInstances: PropTypes.number,
              description: PropTypes.string,
              componentType: PropTypes.oneOf(['thumbnail', 'thumbnailTracked', 'thumbnailNoImage'])
                .isRequired,
              isTracked: PropTypes.bool,
              /**
               * Data the thumbnail should expose to a receiving drop target. Use a matching
               * `dragData.type` to identify which targets can receive this draggable item.
               * If this is not set, drag-n-drop will be disabled for this thumbnail.
               *
               * Ref: https://react-dnd.github.io/react-dnd/docs/api/use-drag#specification-object-members
               */
              dragData: PropTypes.shape({
                /** Must match the "type" a dropTarget expects */
                type: PropTypes.string.isRequired,
              }),
            })
          ),
        })
      ).isRequired,
    })
  ),
};

export { StudyBrowser };
